import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SharedService {

  constructor() { }

  private selectedFilters = {
    selectedRegions: [] as number[],
    selectedAssets: [] as number[],
    selectedDeposits: [] as number[],
    inputSearched: ''
  };

  setSelectedFilters(selectedFilters: any) {
    this.selectedFilters = { ...selectedFilters };
  }

  getSelectedFilters() {
    return this.selectedFilters;
  }

  clearFilters() {
    this.selectedFilters = {
      selectedRegions: [],
      selectedAssets: [],
      selectedDeposits: [],
      inputSearched: ''
    };
  }

}
